<div
  class="ui basic segment"
  style="margin: -45px -20px"
  lmsPadding
  paddingT="5px"
  paddingX="10"
>
  <div class="ui stackable grid" appMargin marginT="10px" marginB="5px">
    <div style="display: flex" class="ui column four wide">
      <div style="position: relative; top: 8px; cursor: pointer">
        <img (click)="goBack()" src="assets/icons/left-arrow-icon.svg" alt="" />
      </div>
      <div style="margin-left: 15px" class="equipment-id">
        <h6
          style="
            color: #6d7175;
            font-weight: 400;
            font-size: 10px;
            margin: -15px 0;
          "
        >
          Home / Settings/ Application Security
        </h6>
        <div
          style="
            font-weight: 500 !important;
            margin-bottom: 10px;
            color: #3f4395;
          "
          class="ui large header theme-color"
        >
          Geofencing
        </div>
      </div>
    </div>
    <div *ngIf="isAddCountryRoute()" class="ui right aligned twelve wide column">
    <button (click)="addCountry()" style="font-weight: 400;" class="ui primary button">Add Country</button>
    </div>
  </div>
  <div class="ui divider"></div>

  <div class="ui secondary sub pointing menu">
    <div
      class="ui item"
      [routerLink]="['./dashboard']"
      routerLinkActive="active"
    >
      Geofencing Dashboard
      <!-- <div class="ui blue label mini circular">0</div> -->
    </div>
    <div class="ui item" [routerLink]="['./logs']" routerLinkActive="active">
      Geofencing Logs
      <!-- <div class="ui blue label mini circular">0</div> -->
    </div>
    <div
      class="ui item"
      [routerLink]="['./user-profile-settings']"
      routerLinkActive="active"
    >
      Geofencing User Profile Setting
    </div>
    <div
      class="ui item"
      [routerLink]="['./global-settings']"
      routerLinkActive="active"
    >
      Geofence Global Settings
    </div>
    <div class="ui item" [routerLink]="['./users']" routerLinkActive="active">
      Geofence Users
    </div>
  </div>
  <div class="ui basic segment w-100">
    <router-outlet></router-outlet>
  </div>
</div>
